import {
  CircularProgress,
  Dialog,
  Fab,
  Snackbar
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Component } from "react";
import swal from "sweetalert";

import { HomeOutlined, Navigation } from "@mui/icons-material";
import MuiAlert from "@mui/lab/Alert";
import { Map, is } from "immutable";
import UbereatsActionCreator from "../../controller/action/UbereatsActionCreator";
import { FOXORDER_V2 } from "../../controller/constant/ActionConstant";
import { DeliveraStore } from "../../controller/model/delivera/DeliveraStore";
import { StoreKeyType } from "../../controller/model/delivera/interface";
import PopinaRestaurant from "../../controller/model/popina/PopinaRestaurant";
import Service from "../../controller/model/service/Service";
import FoxOrderStoreShared from "../../controller/store/FoxOrderStore";
import ObyPayStoreShared from "../../controller/store/ObyPayStore";
import Environment from "../../utils/Environement";
import CategoryComponent from "./category/CategoryComponent";

const tabs = [
    {
        index: 0,
        name: 'deliveroo',
    },
    {
        index: 1,
        name: 'ubereats'
    },
    {
        index: 2,
        name: 'hubrise'
    },
    {
        index: 3,
        name: `${FOXORDER_V2}`
    },
    {
        index: 4,
        name: 'obypay'
    }
];

interface PropsIterface {
  service: Map<StoreKeyType, Service>;
  stores: Map<StoreKeyType, DeliveraStore>;
  restaurant: PopinaRestaurant;
}

interface StateInterface {
  currentTabValue: 0 | 1 | 2 | 3 | 4;
  selectedStore: DeliveraStore;
  showSuccess: boolean;
  successMessage: string | undefined;
  showError: boolean;
  showLoading: boolean;
  message: string | undefined;
  loaderAlertIsOpen: boolean;
  visible: boolean;
}

class MappingContainer extends Component {
  public state: StateInterface;
  public props: PropsIterface;

  constructor(props: any) {
    super(props);
    this.state = {
      currentTabValue: 0,
      selectedStore: props.stores.get("deliveroo"),
      showSuccess: false,
      successMessage: "",
      showError: false,
      showLoading: false,
      message: "",
      loaderAlertIsOpen: false,
      visible: true,
    };
    this.props = props;
    this._handleChangeTab = this._handleChangeTab.bind(this);
    this._hanldeCLoseLoadingSnackBar = this._hanldeCLoseLoadingSnackBar.bind(
      this
    );
    this._handleCloseErrorSnackBar = this._handleCloseErrorSnackBar.bind(this);
    this._handleClickSendMenu = this._handleClickSendMenu.bind(this);
    this._showSuccessSendMenuSnackBar = this._showSuccessSendMenuSnackBar.bind(
      this
    );
    this._showErrorSendMenuSnackbar = this._showErrorSendMenuSnackbar.bind(
      this
    );
    this._handleCloseSuccessSnackBar = this._handleCloseSuccessSnackBar.bind(
      this
    );
  }

  _handleChangeTab(index: number) {
    this.setState({
      currentTabValue: index,
      selectedStore: this.props.stores.get(tabs[index].name as StoreKeyType),
      visible: !this.state.visible,
    });
  }

  componentDidUpdate(prevProps: PropsIterface) {
    const selectedService = tabs[this.state.currentTabValue];
    if (
      false === is(prevProps.stores, this.props.stores) &&
      false ===
      is(
        this.state.selectedStore,
        this.props.stores.get(selectedService.name as StoreKeyType)
      )
    ) {
      this.setState({
        selectedStore: this.props.stores.get(
          selectedService.name as StoreKeyType
        ),
      });
    }
  }

  _hanldeCLoseLoadingSnackBar() {
    this.setState({ showLoading: false });
  }

  _handleCloseErrorSnackBar() {
    this.setState({ showError: false, message: "" });
  }

  _handleCloseSuccessSnackBar() {
    this.setState({ showSuccess: false, successMessage: "" });
  }

  _handleClickSendMenu(_e: any) {
    const provider = this.state.selectedStore.provider;
    swal({
      title: "Envoyer le Menu ?",
      text: `Êtes vous sur de vouloir envoyer le Menu à ${provider === "ubereats" ? "Uber eats" : "deliveroo"
        }`,
      icon: "warning",
      buttons: ["Non", "Oui"],
      dangerMode: true,
    }).then((result) => {
      if (result === true) {
        this.setState({
          loaderAlertIsOpen: true,
        });
        if (provider === "ubereats") {
          UbereatsActionCreator.sendStoreToUbereast(
            this.state.selectedStore,
            this.props.service.get(this.state.selectedStore.provider)!
          )
            .then(() => {
              this.setState({
                loaderAlertIsOpen: false,
              });
              this._showSuccessSendMenuSnackBar(provider);
            })
            .catch((e) => {
              console.warn(e);
              this.setState({
                loaderAlertIsOpen: false,
              });
              this._showErrorSendMenuSnackbar(provider);
            });
        } else if (provider === "deliveroo") {
          // DeliverooActionCreators.sendDeliverooMenu(this.state.selectedStore).then((_res) => {
          //     this.setState({ loaderAlertIsOpen: false });
          //     this._showSuccessSendMenuSnackBar(provider);
          // }).catch((err) => {
          //     console.log(err);
          //     this.setState({ loaderAlertIsOpen: false });
          //     this._showErrorSendMenuSnackbar(provider);
          // });
        }
      }
    });
  }

  _showSuccessSendMenuSnackBar(provider: StoreKeyType) {
    this.setState({
      showSuccess: true,
      successMessage: `Envoie du Menu à ${provider} réussie`,
    });
  }

  _showErrorSendMenuSnackbar(provider: StoreKeyType) {
    this.setState({
      showError: true,
      message: `Erreur lors de l'envoie du Menu à ${provider}`,
    });
  }

  render() {
    if (!this.state.visible) {
      return this.state.selectedStore === undefined ? (
        <div>
          <BackHomeButton
            onClick={() => {
              this.setState({ visible: !this.state.visible });
            }}
            style={{ marginBottom: "46px" }}
          >
            RETOUR
            <HomeOutlined
              style={{
                marginLeft: "17px",
              }}
            />{" "}
          </BackHomeButton>
          <p style={{ fontSize: "19px", color: "#474F5E", margin: "inherit" }}>
            {" "}
            { this.state.currentTabValue === 3 ? (
              <div>
                {
                FoxOrderStoreShared.service.isActive ? (
                  <>
                    <h1>Un compte Fox Order V2 est activé.</h1>
                    <p><p style={{ fontWeight: 'bold' }}>Account name :</p> {FoxOrderStoreShared.service.accountName}</p>
                    <p><p style={{ fontWeight: 'bold' }}>Uid Firebase :</p> {FoxOrderStoreShared.service.uid}</p>
                    <p><p style={{ fontWeight: 'bold' }}>Active :</p> {FoxOrderStoreShared.service.isActive}</p>
                  </>
                ) : null
                }
              </div>
            ) : this.state.currentTabValue === 4 ? (
              <div>
                {
                ObyPayStoreShared.service.isActive ? (
                  <>
                    <h1>Un compte Obypay est activé.</h1>
                    <p><p style={{ fontWeight: 'bold' }}>Account name :</p> {ObyPayStoreShared.service.accountName}</p>
                    <p><p style={{ fontWeight: 'bold' }}>Uid Firebase :</p> {ObyPayStoreShared.service.uid}</p>
                    <p><p style={{ fontWeight: 'bold' }}>Active :</p> {ObyPayStoreShared.service.isActive}</p>
                    <p><p style={{ fontWeight: 'bold' }}>Token used :</p> { ObyPayStoreShared.service.accessToken }</p>
                    <p><p style={{ fontWeight: 'bold' }}>Current listener ID :</p> { ObyPayStoreShared.service.listenerId }</p>
                  </>
                ) : null 
                }
              </div>
            )
            : <p> Aucun compte {tabs[this.state.currentTabValue].name} activé{" "}</p>
            }
          </p>{" "}
        </div>
      ) : (
          <div style={{ backgroundColor: "#f9fafa" }}>
            <BackHomeButton
              onClick={() => {
                this.setState({ visible: !this.state.visible });
              }}
              style={{ marginBottom: "-46px" }}
            >
              RETOUR
            <HomeOutlined
                style={{
                  marginLeft: "17px",
                }}
              />{" "}
            </BackHomeButton>
            <div style={{ position: "fixed", bottom: 40, right: 50, zIndex: 10 }}>
              <Fab
                color="secondary"
                style={{ color: "white" }}
                onClick={this._handleClickSendMenu}
              >
                <Navigation />
              </Fab>
            </div>

            <CategoryComponent
              store={this.state.selectedStore}
              restaurant={this.props.restaurant}
            />
          </div>
        );
    }

    return (
      <div>
        <Snackbar
          open={this.state.showError}
          autoHideDuration={6000}
          onClose={this._handleCloseErrorSnackBar}
        >
          <MuiAlert severity="error" onClose={this._handleCloseErrorSnackBar}>
            {this.state.message}
          </MuiAlert>
        </Snackbar>
        <Snackbar
          open={this.state.showSuccess}
          autoHideDuration={6000}
          onClose={this._handleCloseSuccessSnackBar}
        >
          <MuiAlert
            severity="success"
            onClose={this._handleCloseSuccessSnackBar}
          >
            {this.state.successMessage}
          </MuiAlert>
        </Snackbar>
        <Snackbar
          open={this.state.showLoading}
          onClose={this._hanldeCLoseLoadingSnackBar}
        >
          <MuiAlert severity="warning">
            <div
              style={{
                display: "flex",
                margin: "auto",
                textAlign: "center",
              }}
            ></div>
            {"Mise à jour du menu, Veuillez patienter ..."}
            <CircularProgress size={20} style={{ marginLeft: "20px" }} />
          </MuiAlert>
        </Snackbar>
        <Dialog
          open={this.state.loaderAlertIsOpen}
          color="transparent"
          fullScreen={true}
          PaperProps={{
            style: {
              backgroundColor: "transparent",
              boxShadow: "none",
            },
          }}
        >
          <div
            style={{
              backgroundColor: "transparent",
              width: "100%",
              height: "auto",
              textAlign: "center",
              margin: "auto",
            }}
          >
            <CircularProgress />
          </div>
        </Dialog>

        <div
          style={{
            marginTop: "15em",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
          }}
        >
          {tabs.map((aTab, index) => {
            return aTab.name === "deliveroo" ? null : (
              <StyledButton
                key={aTab.index}
                onClick={() => this._handleChangeTab(aTab.index)}
              >
                {aTab.name}
              </StyledButton>
            );
          })}
        </div>
      </div>
    );
  }
}

const StyledButton = styled('button')({
    backgroundColor: "#F1F1F5",
    width: "1000px",
    fontSize: "40px",
    padding: "45px",
    color: "#474F5E",
    fontWeight: "bold",
    marginBottom: "2em",
    border: (Environment.isPopina) ? "2px solid #7ABF92" : "2px solid #ffd400",
    textTransform: "capitalize",
    "&:hover": {
      borderColor: "#474F5E",
      color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
      backgroundColor: "#474F5E",
    },
})

const BackHomeButton = styled('button')({
    color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
    padding: "10px",
    border: (Environment.isPopina) ? "1px solid #7ABF92" : "1px solid #ffd400",
    borderRadius: "3px",
    marginTop: "40px",
    marginLeft: "3em",

    "&:hover": {
      borderColor: "#474F5E",
      color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
      backgroundColor: "#474F5E",
    },
})

export default MappingContainer;
